/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SetCustomEmailSettingsRequestSettingsBasicAuth } from './SetCustomEmailSettingsRequestSettingsBasicAuth';
import {
    SetCustomEmailSettingsRequestSettingsBasicAuthFromJSON,
    SetCustomEmailSettingsRequestSettingsBasicAuthFromJSONTyped,
    SetCustomEmailSettingsRequestSettingsBasicAuthToJSON,
    SetCustomEmailSettingsRequestSettingsBasicAuthToJSONTyped,
} from './SetCustomEmailSettingsRequestSettingsBasicAuth';
import type { SetCustomEmailSettingsRequestSettingsOauth2Auth } from './SetCustomEmailSettingsRequestSettingsOauth2Auth';
import {
    SetCustomEmailSettingsRequestSettingsOauth2AuthFromJSON,
    SetCustomEmailSettingsRequestSettingsOauth2AuthFromJSONTyped,
    SetCustomEmailSettingsRequestSettingsOauth2AuthToJSON,
    SetCustomEmailSettingsRequestSettingsOauth2AuthToJSONTyped,
} from './SetCustomEmailSettingsRequestSettingsOauth2Auth';

/**
 * SMTP server configuration. Required when `enabled` is `true`.
 * @export
 * @interface SetCustomEmailSettingsRequestSettings
 */
export interface SetCustomEmailSettingsRequestSettings {
    /**
     * SMTP server hostname.
     */
    host: string;
    /**
     * SMTP server port (e.g. 465 for TLS, 587 for STARTTLS).
     */
    port: number;
    /**
     * Authentication method: `basic` for username/password, `oauth2` for OAuth2 token-based auth.
     */
    authMethod: SetCustomEmailSettingsRequestSettingsAuthMethodEnum;
    /**
     * 
     */
    basicAuth?: SetCustomEmailSettingsRequestSettingsBasicAuth;
    /**
     * 
     */
    oauth2Auth?: SetCustomEmailSettingsRequestSettingsOauth2Auth;
    /**
     * `true` to use TLS (port 465), `false` to use STARTTLS (port 587).
     */
    secure: boolean;
    /**
     * Sender display name shown in email clients.
     */
    fromName: string;
    /**
     * Sender email address.
     */
    fromAddress: string;
    /**
     * HTML template for notification type 1 (new findings).
     */
    template1Html: string;
    /**
     * HTML template for notification type 2 (summary/report).
     */
    template2Html: string;
    /**
     * Email subject for notification type 1.
     */
    subject1: string;
    /**
     * Email subject for notification type 2.
     */
    subject2: string;
}


/**
 * @export
 */
export const SetCustomEmailSettingsRequestSettingsAuthMethodEnum = {
    Basic: 'basic',
    Oauth2: 'oauth2',
} as const;
export type SetCustomEmailSettingsRequestSettingsAuthMethodEnum = typeof SetCustomEmailSettingsRequestSettingsAuthMethodEnum[keyof typeof SetCustomEmailSettingsRequestSettingsAuthMethodEnum];


/**
 * Check if a given object implements the SetCustomEmailSettingsRequestSettings interface.
 */
export function instanceOfSetCustomEmailSettingsRequestSettings(value: object): value is SetCustomEmailSettingsRequestSettings {
    if (!('host' in value) || value['host'] === undefined) return false;
    if (!('port' in value) || value['port'] === undefined) return false;
    if (!('authMethod' in value) || value['authMethod'] === undefined) return false;
    if (!('secure' in value) || value['secure'] === undefined) return false;
    if (!('fromName' in value) || value['fromName'] === undefined) return false;
    if (!('fromAddress' in value) || value['fromAddress'] === undefined) return false;
    if (!('template1Html' in value) || value['template1Html'] === undefined) return false;
    if (!('template2Html' in value) || value['template2Html'] === undefined) return false;
    if (!('subject1' in value) || value['subject1'] === undefined) return false;
    if (!('subject2' in value) || value['subject2'] === undefined) return false;
    return true;
}

export function SetCustomEmailSettingsRequestSettingsFromJSON(json: any): SetCustomEmailSettingsRequestSettings {
    return SetCustomEmailSettingsRequestSettingsFromJSONTyped(json, false);
}

export function SetCustomEmailSettingsRequestSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetCustomEmailSettingsRequestSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'host': json['host'],
        'port': json['port'],
        'authMethod': json['authMethod'],
        'basicAuth': json['basicAuth'] == null ? undefined : SetCustomEmailSettingsRequestSettingsBasicAuthFromJSON(json['basicAuth']),
        'oauth2Auth': json['oauth2Auth'] == null ? undefined : SetCustomEmailSettingsRequestSettingsOauth2AuthFromJSON(json['oauth2Auth']),
        'secure': json['secure'],
        'fromName': json['fromName'],
        'fromAddress': json['fromAddress'],
        'template1Html': json['template1Html'],
        'template2Html': json['template2Html'],
        'subject1': json['subject1'],
        'subject2': json['subject2'],
    };
}

export function SetCustomEmailSettingsRequestSettingsToJSON(json: any): SetCustomEmailSettingsRequestSettings {
    return SetCustomEmailSettingsRequestSettingsToJSONTyped(json, false);
}

export function SetCustomEmailSettingsRequestSettingsToJSONTyped(value?: SetCustomEmailSettingsRequestSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'host': value['host'],
        'port': value['port'],
        'authMethod': value['authMethod'],
        'basicAuth': SetCustomEmailSettingsRequestSettingsBasicAuthToJSON(value['basicAuth']),
        'oauth2Auth': SetCustomEmailSettingsRequestSettingsOauth2AuthToJSON(value['oauth2Auth']),
        'secure': value['secure'],
        'fromName': value['fromName'],
        'fromAddress': value['fromAddress'],
        'template1Html': value['template1Html'],
        'template2Html': value['template2Html'],
        'subject1': value['subject1'],
        'subject2': value['subject2'],
    };
}

